import { FC } from 'react';
import { Tag } from 'antd';

type Props = { tags?: string[] };

export const Tags: FC<Props> = ({ tags = [] }) => {
  return (
    <>
      {tags.map((tag) => (
        <Tag key={tag} style={{ fontWeight: 600 }}>
          #{tag}
        </Tag>
      ))}
    </>
  );
};
